
import { Phone, Mail, MapPin } from "lucide-react";
import { ContactInfoCard } from "./ContactInfoCard";
import { BusinessHours } from "./BusinessHours";

export const ContactInfo = () => {
  return (
    <div className="space-y-8">
      <ContactInfoCard />
      <BusinessHours />
    </div>
  );
};
